var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    fill: _vm.color
  }),attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xlink:href":"/images/good.svg#good"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }